import { Component, OnInit, ViewChild } from '@angular/core';
import { Usuario } from '../../models/usuario';
import { UsuarioService } from '../../services/usuario.service';

import { CustomAlertComponent } from '../../shared/custom-alert/custom-alert.component';

@Component({
  selector: 'app-olvide-password',
  templateUrl: './olvide-password.component.html',
  styleUrls: ['./olvide-password.component.scss']
})
export class OlvidePasswordComponent implements OnInit {

  usuario: Usuario = {
    password: null,
    username: null
  };

  alert: any = {
    tipo: "success",
    titulo: "",
    mensaje: "",
    visible: false
  }

  errores: Array<string> = [];

  @ViewChild(CustomAlertComponent)
  private alertComponent: CustomAlertComponent;

  constructor(private usuarioService: UsuarioService) { }

  ngOnInit() {
  }

  recuperar() {

    this.alert.visible = false;

    this.usuarioService.recuperarContraseña(this.usuario.username)
      .map(result => {
        this.alert.visible = true;
        this.alert.titulo = "Recuperar Contraseña";
        if (result.status == 201) {
          this.alert.tipo = "success"
          this.alert.mensaje = "Hemos enviado un correo con los pasos a seguir para recuperar su contraseña. Por favor verifique su email."
        } else {
          this.alert.tipo = "danger"
          this.alert.mensaje = "No hemos podido enviar el correo con las instrucciones para recuperar su contraseña. Por favor vuelva a intentarlo."
        }
        this.alertComponent.setType(this.alert.tipo);
      })
      .subscribe(data => {

      }, error => {
        var json = error.json();
        this.alert.visible = true;
        this.alert.titulo = "Recuperar Contraseña";
        this.alert.tipo = "danger"
        this.alertComponent.setType(this.alert.tipo);
        this.alert.mensaje = "No hemos podido enviar el correo con las instrucciones para recuperar su contraseña. Por favor vuelva a intentarlo."
        if (json.modelState) {
          for (var key in json.modelState) {
            if (json.modelState[key].length == 1) {
              this.errores.push(json.modelState[key]);
            } else {
              for (var i = 0; i < json.modelState[key].length; i++) {
                this.errores.push(json.modelState[key][i]);
              }
            }
          }
        }
      });
  }

}



// WEBPACK FOOTER //
// C:/Source/eSoftCereal.API/eSoftCereal.UI/src/app/usuarios/olvide-password/olvide-password.component.ts